import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import ModalComponent from '../../components/ModalComponent'
import {
	get_all_properties,
	reset,
	create_property,
	update_property,
	delete_property,
} from '../../features/property/propertySlice'
import Loader from '../../components/Preloader'
import { comma } from '../../utils/helper'
import { GrTrash, GrFormEdit } from 'react-icons/gr'
import { IconContext } from 'react-icons'

const DashboardProperty = () => {
	const dispatch = useDispatch()

	const { loading, success, properties } = useSelector(
		(state) => state.propertyGetTypes
	)

	const [openModal, setOpenModal] = useState(false)

	const [propertyName, setPropertyName] = useState('')
	const [location, setLocation] = useState('')
	const [title, setTitle] = useState('')
	const [price, setPrice] = useState('')
	const [propertyType, setPropertyType] = useState('')
	const [description, setDescription] = useState('')
	const [id, setId] = useState(null)
	const [ImageArray, setImageArray] = useState([])
	const [message, setMessage] = useState(null)

	const [mainImage, setMainImage] = useState(null)
	const [uploadedImage, setUploadedImage] = useState('')
	const [uploading, setUploading] = useState(false)

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	const getBase64 = (file) => {
		return new Promise((resolve) => {
			let baseURL = ''
			let reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => {
				// Make a fileInfo Object
				baseURL = reader.result
				resolve(baseURL)
			}
		})
	}

	const handleFileInputChange = async (e) => {
		let file = e.target.files[0]
		setMainImage(file)
		getBase64(file)
			.then((result) => {
				file['base64'] = result
				console.log('File Is', file)
				// let split = file.base64.split(',');
				// setImageFile(split[1]);
				// let type = file.type.split('/');
				// setImageFormat(type[1]);
			})
			.catch((err) => {
				console.log(err)
			})

		await uploadFileHandler(file)
	}

	const uploadFileHandler = (mainImage) => {
		const formData = new FormData()
		formData.append('file', mainImage)
		formData.append('image', mainImage)
		formData.append('upload_preset', 'showel')
		formData.append('cloud_name', 'dtjokkpas')

		setUploading(true)

		fetch('https://api.cloudinary.com/v1_1/dtjokkpas/image/upload', {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setUploading(false)
				setMainImage(null)
				setUploadedImage(data.url)
				// setImageFile('')
			})
			.catch((err) => {
				console.log(err)
				setUploading(false)
				setMainImage(null)
				// setImageFile('')
			})
	}

	const editHandler = (e, data) => {
		e.preventDefault()
		setId(data._id)
		setPropertyName(data.propertyName)
		setLocation(data.location)
		setTitle(data.title)
		setPrice(data.price)
		setPropertyType(data.propertyType)
		setDescription(data.description)
		setOpenModal(true)
	}

	const deleteHandler = (e, id) => {
		e.preventDefault()
		if (window.confirm('Are you sure?')) {
			dispatch(delete_property(id))
		}
	}

	const submitHandler = (e) => {
		e.preventDefault()

		if (id === null) {
			if (uploadedImage !== '') {
				if (
					ImageArray !== [] &&
					propertyName !== '' &&
					location !== '' &&
					title !== '' &&
					price !== '' &&
					propertyType !== '' &&
					description !== ''
				) {
					let data = {
						propertyName,
						title,
						price,
						propertyType,
						description,
						location,
						displayImage: uploadedImage,
					}

					dispatch(create_property(data))

					setTimeout(() => {
						setPropertyName('')
						setLocation('')
						setTitle('')
						setPrice('')
						setPropertyType('')
						setDescription('')
						setMessage(null)
						setImageArray([])
						setOpenModal(false)
					}, 1000)
				} else {
					setMessage('Please fill in all details')
				}
			} else {
				setMessage("Couldn't upload image")
			}
		} else {
			let data = {
				propertyName,
				title,
				price,
				propertyType,
				description,
				location,
				displayImage: uploadedImage,
			}
			let obj = {
				id,
				data,
			}
			dispatch(update_property(obj))
			setTimeout(() => {
				setOpenModal(false)
			}, 1000)
		}
	}

	const categoryHead = [
		'S/N',
		'Property Name',
		'Location',
		'Title',
		'Price',
		'Type of Property',
		'Edit',
		'Delete',
	]
	let i = 0

	useEffect(() => {
		dispatch(get_all_properties())

		return () => {
			dispatch(reset())
		}
	}, [dispatch, success])

	return (
		<section className='user_dashboard'>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 text-right'>
						<Link
							to='#'
							onClick={(e) => {
								e.preventDefault()
								setOpenModal(true)
								setId(null)
								setPropertyName('')
								setLocation('')
								setTitle('')
								setPrice('')
								setPropertyType('')
								setDescription('')
							}}
							className='btn btn-danger text-white'
						>
							Create Property
						</Link>
					</div>

					<div className='col-12'>
						{loading ? (
							<Loader />
						) : (
							<>
								{properties &&
								properties.properties &&
								properties.properties.length > 0 ? (
									<div className='mt-5 table-responsive shadow-sm'>
										<table className='table table-bordered table-striped'>
											<thead className='' style={{ fontSize: '14px' }}>
												<tr>
													{categoryHead.map((cate, i) => (
														<th key={i}>{cate}</th>
													))}
												</tr>
											</thead>
											<tbody>
												{properties.properties.map((l, i) => (
													<tr key={l._id}>
														<td>{++i}</td>
														<td>
															<Link to={`/admin/dashboard/properties/${l._id}`}>
																{l.propertyName}
															</Link>
														</td>
														<td> {l.location} </td>
														<td> {l.title} </td>
														<td>
															<span>&#8358;</span>
															{comma(l.price)}
														</td>
														<td> {l.propertyType} </td>
														<td>
															<Link to='#' onClick={(e) => editHandler(e, l)}>
																<GrFormEdit size={20} />
															</Link>
														</td>
														<td>
															<a
																href='#'
																className=' text-white'
																onClick={(e) => deleteHandler(e, l._id)}
															>
																<IconContext.Provider
																	value={{
																		color: 'white',
																		className: 'global-class-name',
																	}}
																>
																	<div>
																		<GrTrash size={15} />
																	</div>
																</IconContext.Provider>
															</a>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								) : (
									<div className='card mt-3'>
										<div className='card-body'>
											<p className='nothing'>No Properties found</p>
										</div>
									</div>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<ModalComponent
				open={openModal}
				toggle={toggleModal}
				size='xl'
				title={` ${id ? 'Edit' : 'Add'} Campaign`}
			>
				<div className='login_form'>
					<form className='tagForm' onSubmit={submitHandler}>
						<label htmlFor='propertyName' className='label'>
							Property Name
						</label>
						<input
							type='text'
							id='propertyName'
							value={propertyName}
							className='form-control mb-3'
							onChange={(e) => setPropertyName(e.target.value)}
						/>
						<label htmlFor='location' className='label'>
							Location
						</label>
						<input
							type='text'
							id='location'
							value={location}
							className='form-control mb-3'
							onChange={(e) => setLocation(e.target.value)}
						/>
						<label htmlFor='title' className='label'>
							Title
						</label>
						<input
							type='text'
							id='title'
							value={title}
							className='form-control mb-3'
							onChange={(e) => setTitle(e.target.value)}
						/>
						<label htmlFor='price' className='label'>
							Price
						</label>
						<input
							type='number'
							id='price'
							value={price}
							className='form-control mb-3'
							onChange={(e) => setPrice(e.target.value)}
						/>
						<label htmlFor='propertyType' className='label'>
							Property Type
						</label>
						<select
							value={propertyType}
							id='propertyType'
							onChange={(e) => setPropertyType(e.target.value)}
							className='form-select mb-3'
						>
							<option value=''> -- select type -- </option>
							<option value='land'>Land</option>
							<option value='house'>House</option>
						</select>
						<label htmlFor='Description'>Description</label>
						<textarea
							// value={info}
							id='Description'
							onChange={(e) => setDescription(e.target.value)}
							cols='30'
							className='form-control mb-3'
							rows='3'
						></textarea>
						<label htmlFor=''>Apartment Image</label>
						<input
							type='file'
							id=''
							className='form-control'
							onChange={handleFileInputChange}
						/>
						{uploading && <i className='fas fa-spinner'></i>}

						<div className='d-flex justify-content-between mt-4'>
							<div>
								<button
									disabled={loading ? true : uploading ? true : false}
									className='btn btn-secondary'
								>
									{loading ? (
										<i className='fas fa-spinner fa-spin'></i>
									) : id ? (
										'Update'
									) : (
										'Create'
									)}
								</button>
								<p style={{ fontSize: '12px', color: 'red' }}> {message} </p>
							</div>
						</div>
					</form>
				</div>
			</ModalComponent>
		</section>
	)
}

export default DashboardProperty
